import clsx from 'clsx';
import { MinusIcon, PlusIcon } from 'components/Icon/Icon';
import { IconButton } from 'components/buttons/IconButton/IconButton';
import { DEFAULT_COUNT, DEFAULT_MAX_COUNT, DEFAULT_MIN_COUNT } from '../constants';
import styles from './CounterInput.css';

interface CounterInputProps {
	testId: string;
	count: number;
	onCountChange: (newCount: number) => void;
	minCount?: number;
	maxCount?: number;
}

export const CounterInput: React.FC<CounterInputProps> = ({
	testId,
	count = DEFAULT_COUNT,
	minCount = DEFAULT_MIN_COUNT,
	maxCount = DEFAULT_MAX_COUNT,
	onCountChange,
}) => {
	const isMinusDisabled = count <= minCount;
	const isPlusDisabled = count >= maxCount;

	const updateCount = (newCount: number) => {
		const totalCount = count + newCount;

		if (totalCount < minCount || totalCount > maxCount) {
			return;
		}

		onCountChange(totalCount);
	};

	return (
		<div className={styles.root} data-testid={testId}>
			<IconButton
				testId={`${testId}-decrement-button`}
				Icon={MinusIcon}
				onClick={() => updateCount(-1)}
				rootClass={clsx({ [styles.disabled]: isMinusDisabled })}
				disabled={isMinusDisabled}
			/>
			<span className={styles.count}>{count}</span>
			<IconButton
				testId={`${testId}-increment-button`}
				Icon={PlusIcon}
				onClick={() => updateCount(1)}
				rootClass={clsx({ [styles.disabled]: isPlusDisabled })}
				disabled={isPlusDisabled}
			/>
		</div>
	);
};
